import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import SlideshowItem from './SlideshowItem'
import ListButtonItem from './ListButtonItem'
import LabelItem from './LabelItem'
import ImageItem from './ImageItem'
import ButtonItem from './ButtonItem'

export default {
  name: 'ServiceScreenSettingInput',
  components: {
    Loading,
    SlideshowItem,
    ListButtonItem,
    LabelItem,
    ImageItem,
    ButtonItem
  },
  data () {
    return {
      // input
      inpScreenName: null,
      inpHomeScreen: false
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceScreenSetting.categoryName,

      // form
      serviceId: state => state.serviceScreenSettingForm.serviceId,
      serviceContentsId: state => state.serviceScreenSettingForm.serviceContentsId,
      contentsScreenId: state => state.serviceScreenSettingForm.targetId,

      // value
      values: state => state.serviceScreenSettingForm.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept,

      // validate
      validates: state => state.serviceScreenSettingForm.validates
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
      isRegister: 'serviceScreenSettingForm/isRegister',
      isModify: 'serviceScreenSettingForm/isModify',
      formIsValid: 'serviceScreenSettingForm/formIsValid',
    }),

    // slideshow
    showSlideShow () {
      return this.values.screenSlideShowSettings &&
        this.values.screenSlideShowSettings.length > 0
    },
    slideShowList () {
      return this.values.screenSlideShowSettings
    },
    // listButton
    showListButton () {
      return this.values.screenListBtnSettings &&
        this.values.screenListBtnSettings.length > 0
    },
    listButtonList () {
      return this.values.screenListBtnSettings
    },
    // label
    showLabel () {
      return this.values.screenLabelSettings &&
        this.values.screenLabelSettings.length > 0
    },
    labelList () {
      return this.values.screenLabelSettings
    },
    // image
    showImage () {
      return this.values.screenImageSettings &&
        this.values.screenImageSettings.length > 0
    },
    imageList () {
      return this.values.screenImageSettings
    },
    // button
    showButton () {
      return this.values.screenBtnSettings &&
        this.values.screenBtnSettings.length > 0
    },
    buttonList () {
      console.log('buttonList', this.values.screenBtnSettings)
      return this.values.screenBtnSettings
    },

    // result
    screenCode () {
      if (!this.values.screenNameSetting) return ''
      return this.values.screenNameSetting.screenCode
    },
    screenConfigName () {
      if (!this.values.screenNameSetting) return ''
      return this.values.screenNameSetting.screenConfigName
    },

    // validate
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
    },
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
    }),
    ...mapMutations({
      // setValues: 'serviceScreenSettingForm/setValues',
      // setInputValue: 'serviceScreenSettingForm/setInputValue'
    }),

    init () {
      this.inpScreenName = this.values.screenNameSetting
        ? this.values.screenNameSetting.screenName
        : ''
      this.inpHomeScreen = this.values.isHomeScreen
    },
    turnBack () {
      this.$router.push({
        name: 'ServiceScreenSetting',
        params: {
          serviceId: this.serviceId,
          serviceContentsId: this.serviceContentsId
        }
      })
    },

    confirmData () {
      // validate
      if (this.formIsValid) {
        // console.log('refs', this.$refs)
        Object.keys(this.$refs).forEach(key => {
          // slideshow
          if (key.indexOf('slideshow') === 0) {
            console.log(key, this.$refs[key][0].getJsonb)
          }
          // listbutton
          if (key.indexOf('listbutton') === 0) {
            console.log(key, this.$refs[key][0].getJsonb)
          }
          // label
          if (key.indexOf('label') === 0) {
            console.log(key, this.$refs[key][0].getJsonb)
          }
          // image
          if (key.indexOf('image') === 0) {
            console.log(key, this.$refs[key][0].getJsonb)
          }
          // button
          if (key.indexOf('button') === 0) {
            console.log(key, this.$refs[key][0].getJsonb)
          }
        })

        this.showConfirm({
          key: 'register',
          title: '',
          body: 'この' + this.categoryName + 'を変更しますか？'
        })
      }
    },

    postData () {
      this.processing = true

      // jsonb
      const jsonb = {
        screenNameSetting: {
          screenCode: this.values.screenNameSetting.screenCode,
          screenName: this.inpScreenName,
          screenConfigName: this.values.screenNameSetting.screenConfigName,
        },
        isHomeScreen: this.inpHomeScreen,
      }
      // jsonb : modules
      Object.keys(this.$refs).forEach(key => {
        // slideshow
        if (key.indexOf('slideshow') === 0) {
          if (jsonb.screenSlideShowSettings === undefined) {
            jsonb.screenSlideShowSettings = []
          }
          jsonb.screenSlideShowSettings.push(this.$refs[key][0].getJsonb)
        }
        // listbutton
        if (key.indexOf('listbutton') === 0) {
          if (jsonb.screenListBtnSettings === undefined) {
            jsonb.screenListBtnSettings = []
          }
          jsonb.screenListBtnSettings.push(this.$refs[key][0].getJsonb)
        }
        // label
        if (key.indexOf('label') === 0) {
          if (jsonb.screenLabelSettings === undefined) {
            jsonb.screenLabelSettings = []
          }
          jsonb.screenLabelSettings.push(this.$refs[key][0].getJsonb)
        }
        // image
        if (key.indexOf('image') === 0) {
          if (jsonb.screenImageSettings === undefined) {
            jsonb.screenImageSettings = []
          }
          jsonb.screenImageSettings.push(this.$refs[key][0].getJsonb)
        }
        // button
        if (key.indexOf('button') === 0) {
          if (jsonb.screenBtnSettings === undefined) {
            jsonb.screenBtnSettings = []
          }
          jsonb.screenBtnSettings.push(this.$refs[key][0].getJsonb)
        }
      })

      //
      let parameters = {
        serviceUuid: this.serviceId,
        serviceContentsUuid: this.serviceContentsId,
        ContentsScreenUuid: this.contentsScreenId,
        request: {
          screenSettings: jsonb
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceContentsSetting'],
        ['v1ServiceContentsScreenPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.categoryName + 'の変更',
              body: this.categoryName + 'を変更しました。'
            })

            // 
            this.$router.push({
              name: 'ServiceScreenSetting',
              params: {
                serviceId: this.serviceId,
                serviceContentsId: this.serviceContentsId
              }
            })

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    }
  }
}
